import { createAction, props } from '@ngrx/store'
import { SalaryComponent } from './salary-components.state'

// Load salary components by componentType
export const loadSalaryComponents = createAction(
  '[SalaryComponents] Load SalaryComponents',
  props<{ componentType: string; belongsTo: string | null }>()
)

export const loadSalaryComponentsSuccess = createAction(
  '[SalaryComponents] Load SalaryComponents Success',
  props<{ componentType: string; salaryComponents: SalaryComponent[] }>()
)

export const loadSalaryComponentsFailure = createAction(
  '[SalaryComponents] Load SalaryComponents Failure',
  props<{ error: string }>()
)

// Add Salary Component
export const addSalaryComponent = createAction(
  '[SalaryComponents] Add SalaryComponent',
  props<{ salaryComponent: SalaryComponent }>()
)

export const addSalaryComponentSuccess = createAction(
  '[SalaryComponents] Add SalaryComponent Success',
  props<{ salaryComponent: SalaryComponent }>()
)

export const addSalaryComponentFailure = createAction(
  '[SalaryComponents] Add SalaryComponent Failure',
  props<{ error: string }>()
)

// Edit Salary Component
export const editSalaryComponent = createAction(
  '[SalaryComponents] Edit SalaryComponent',
  props<{ id: string; salaryComponent: SalaryComponent }>()
)

export const editSalaryComponentSuccess = createAction(
  '[SalaryComponents] Edit SalaryComponent Success',
  props<{ salaryComponent: SalaryComponent }>()
)

export const editSalaryComponentFailure = createAction(
  '[SalaryComponents] Edit SalaryComponent Failure',
  props<{ error: string }>()
)

// Delete Salary Component
export const deleteSalaryComponent = createAction(
  '[SalaryComponents] Delete SalaryComponent',
  props<{ id: string; componentType: string }>() // Need type to update state correctly
)

export const deleteSalaryComponentSuccess = createAction(
  '[SalaryComponents] Delete SalaryComponent Success',
  props<{ id: string; componentType: string }>()
)

export const deleteSalaryComponentFailure = createAction(
  '[SalaryComponents] Delete SalaryComponent Failure',
  props<{ error: string }>()
)
